<template>
    <b-container fluid>
    <Report/>
    </b-container>
</template>
<script>
    import Report from '@/components/Global/ReportSimulacro'


    export default {
        name: 'ResultsGroupGraf',
        components: {Report},
        data: () => ({
    
        }),
        computed: {
        },
        created() {
           
        },
        mounted() {
        },
        methods: {
          
            }
        }
</script>